import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { Formatter } from '../common/services/formatter';
import { FormValidator } from '../common/services/formValidator.service';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { PincodeHandlerService } from '../common/services/pincodeHandler.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { HomeComponent } from '../home/home.component';
import { SharedService } from 'src/app/common/services/sharedService';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { GetGoingCall } from '../getGoingNow/getGoingNow.service';
import { DrawerComponent } from '../common/utilities/drawer/drawer.component';
import { MoreAboutYouCall } from './../questionnaireModule/moreAboutYou/moreAboutYou.service';
import { WhatsappConsentService } from 'src/app/common/services/consent.service';
import { AppSummaryContent } from '../detailsModule/personalDetails/content';
import { GoogleAnalyticsService } from '../common/services/google_analytics.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
import { PlanDetailsService } from '../common/services/planDetails.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { HomeService } from '../home/home.service';

const GENDER_LIST = ['Male', 'Female'];

const INSURED_MEMBER_TYPES = [
    {
        id: '01',
        title: 'Self'
    },
    {
        id: '02',
        title: 'Spouse'
    },
];

const INSURED_OTHER_MEMBER_TYPES = [
    {
        id: '05',
        title: 'Father'
    },
    {
        id: '06',
        title: 'Mother'
    },

];

const SON = 'Son';
const DAUGHTER = 'Daughter';
@Component({
    templateUrl: './getGoingNowEdit.template.html',
    styleUrls: ['./getGoingNowEdit.style.scss'],
    providers: [HomeComponent, GetGoingCall, MoreAboutYouCall]
})
export class GetGoingEditComponent implements OnInit {
    public genderList = GENDER_LIST;
    public selectedGender: string;
    public cityName: any;
    public DOB_DATE_RANGES: any;
    @ViewChildren(PopupComponent) public PopupComponent: QueryList<any>;
    public ContentPopup;
    public Config = { show: false, backdrop: 'static' };
    public GetGoingFormGroup: FormGroup;
    public IsCorrectMobile: string = null;
    public IsValid = false;
    public showLoader = true;
    public lastLimit = 6;
    public InsurerCount = 0;
    public validatePIN: boolean = false;
    public IsEdit = false;
    public isEditForgetGoingEdit = false;
    public insuringFor: string;
    public dobEldest: string;
    public dobProposer: string;
    public ServiceError: any;
    public errorMessage: string;
    public latestPinCode: any;
    public EditResponse;
    public InsurerdResponse;
    public PincodeResponse: string;
    public proposerDobResponse: string;
    public PhoneNumber: any;
    public InsuranceDetails: any;
    public serviceMessage: string;
    public isTncPopupOpen = true;
    public AnswerConfirmationPopupData: { Title: string; Id: string; Config: CustomModalOptions; };
    public InsProductType: any;
    public showOnlyGroupPlan: any;
    public healthOtpFormEdit: FormGroup;
    public showOtpDrawer = false;
    @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
    public IsOTPResend = false;
    public resendOtpExceedFlag = false;
    public mobileOtpTrails = 0;
    public wrongOtpMsg: string;
    public isTimerStarted = false;
    public resendOTPCount = 0;
    public IsServiceFailure = false;
    public mobileNumber;
    public ServiceOTPError: string;
    public whatsAppConsent = true;
    public today = new Date();
    public ShowConsent = false;
    public termsContent = AppSummaryContent.BAGIC;
    public dobforotp: string;
    public bflJourney: any;
    private insuredCount: any;
    public appQuoteCriteriaId;
    hasDobError = false;
    timerOn: boolean;
    timer;
    setTime;
    timerInsuringFor;
    fieldTimer;
    otpFieldtimer;


    // insuring for
    public SonCount = 0;
    public DaughterCount = 0;
    public lastSonCount = 4 - this.DaughterCount;
    public lastDaughterCount = 4 - this.SonCount;
    public MembersAddedLable: string;
    public MembersAddedToList = [];
    public familyCheck = true;
    public SelectInsurerFormGroup: FormGroup;
    public InsuredMemberList = INSURED_MEMBER_TYPES;
    public InsuredOtherMemberList = INSURED_OTHER_MEMBER_TYPES;
    private formattedDOB: any;
    isMobileFlag: any;
    public curr_gender: string;


    constructor(
        private _formBuilder: FormBuilder,
        public FormValidators: FormValidator,
        private formatter: Formatter,
        private _pincodeService: PincodeHandlerService,
        private _sessionHandlerService: SessionHandlerService,
        private _getGoingCall: GetGoingCall,
        private _sharedService: SharedService,
        private routeHandlerService: RouteHandlerService,
        private _moreAboutYouCall: MoreAboutYouCall,
        private _whatsappConsentService: WhatsappConsentService,
        private _googleAnalyticsService: GoogleAnalyticsService,
        public _adobe_analytics_service: adobe_analytics_service,
        private _planDetailsService: PlanDetailsService,
        private _routeContextProvider: RouteContextProvider,
        private _homeService: HomeService,
    ) {

    }
    public ngOnInit() {
        document.getElementById('seohidden').style.display = 'block';
        let url: any = window.location.pathname;
        url = url.split('/');
        this.bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
        this.showLoader = true;
        this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.selectedPlanType]);
        this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.selectedAggregateDeductible]);
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JourneyType, '');
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.selectedPlanType, '');
        this.getTaskDetails();
        this.buildFormGroup();
        this.buildHealthOtpForm();
        this.InsProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);

        this.startFieldTimer();
    }

    private buildFormGroup() {
        const dobValidation = (name) => (control: FormControl) => this.ValidateDOB({ [name]: control.value });
        const proposerDobValidation = (name) => (control: FormControl) => this.ValidateProposerDOB({ [name]: control.value });

        const mustHaveLastName = (control: FormControl) => {
            return !control.value.trim() || control.value.trim().includes(' ')
                ? null
                : { lastNameMandatory: true };
        };

        this.GetGoingFormGroup = this._formBuilder.group({
            proposerName: ['', Validators.compose([Validators.required, mustHaveLastName, this.formatter.removeSpaces])],
            gender: ['', Validators.compose([Validators.required])],
            mobileNumber: ['', Validators.compose([Validators.required])],
            pinCode: ['', Validators.compose([Validators.required])],
            state: [{ value: '', disabled: true }],
            day: ['', Validators.compose([Validators.required, proposerDobValidation('day')])],
            month: ['', Validators.compose([Validators.required, proposerDobValidation('month')])],
            year: ['', Validators.compose([Validators.required, proposerDobValidation('year')])],
            insurerName: [''],
            insuredMembers: [''],
        });
        this.GetGoingFormGroup.valueChanges.subscribe((values) => {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.planPremiumChange, true);
        });

        const formControls = this.InsuredMemberList.map(control => new FormControl(false));
        const OtherMemberformControls = this.InsuredOtherMemberList.map(control => new FormControl(false));

        this.SelectInsurerFormGroup = this._formBuilder.group({
            insurer: new FormArray(formControls),
            son: ['', Validators.compose([])],
            daughter: ['', Validators.compose([])],
            otherInsurer: new FormArray(OtherMemberformControls),
            day: ['', Validators.compose([Validators.required, dobValidation('day'), Validators.min(1), Validators.max(31)])],
            month: ['', Validators.compose([Validators.required, dobValidation('month'), Validators.min(1), Validators.max(12)])],
            year: ['', Validators.compose([Validators.required, dobValidation('year')])],
        });
        this.showLoader = false;
        console.log(typeof (JSON.parse(this._sessionHandlerService.GetSession(CommonConstants.QueryParamsKeys.IsMobile))));
        console.log(typeof ((this._sessionHandlerService.GetSession(CommonConstants.QueryParamsKeys.IsMobile))));
        console.log(this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile))
        if ((this._sessionHandlerService.GetSession(CommonConstants.QueryParamsKeys.IsMobile)) == 'true'
            || JSON.parse(this._sessionHandlerService.GetSession(CommonConstants.QueryParamsKeys.IsMobile)) == true
            || this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1') {
            this.isMobileFlag = true
            this.disableMobileControl();
        } else {
            this.isMobileFlag = false;
        }
        this.FormValidators.subscribeToValueChanges(this.GetGoingFormGroup);
    }
    // Validate Mobile Number
    public ValidateMobile() {
        const mobileNo = this.GetGoingFormGroup
            .controls['mobileNumber'].value.toString();
        const test = /(\d)\1{9}/g;
        if (mobileNo && !this.FormValidators.FieldHasErrors(
            this.GetGoingFormGroup, 'mobileNumber')) {
            if (mobileNo[0] === '6' || mobileNo[0] === '7' || mobileNo[0] === '8' || mobileNo[0] === '9') {
                this.IsCorrectMobile = null;
                this.IsValid = true;
                if (this.bflJourney)
                    this.GetWhatsappConsent();
            } else {
                if (mobileNo.length === 10) {
                    this.IsCorrectMobile = 'Mobile number should start with 6, 7, 8, 9';
                    this.IsValid = false;
                }
            }
            if (mobileNo.match(test)) {
                this.IsCorrectMobile = 'Please provide valid mobile number.';
            }
        } else {
            this.IsCorrectMobile = null;
        }
    }
    // DOB validation
    public ValidateDOB(updatedValue) {
        if (!this.SelectInsurerFormGroup) { return null; }
        const formData = { ...this.SelectInsurerFormGroup.value, ...updatedValue };

        if (formData.day && formData.month && formData.year) {
            let validationErr = null;
            const DOBObj = {
                Day: formData.day,
                Month: formData.month,
                Year: formData.year
            };

            this.DOB_DATE_RANGES = {
                MaxAge: 85,
                MinAge: 18
            };

            const error = this.FormValidators.IsDateOfBirthValid(DOBObj, null, this.DOB_DATE_RANGES.MinAge, this.DOB_DATE_RANGES.MaxAge);
            if (error) {
                console.log(error);
                return { rangeError: error };
            } else {
                const currDate = new Date();
                const dobDate = new Date(DOBObj.Year, DOBObj.Month, DOBObj.Day);
                if (currDate < dobDate) {
                    validationErr = { rangeError: 'Date of birth can\'nt be more than current date' };
                }


                // check proposal dob with eldest dob

                if (this.GetGoingFormGroup.get('day').value && this.GetGoingFormGroup.get('month').value &&
                    this.GetGoingFormGroup.get('year').value) {
                    const formDataProposer = { ...this.GetGoingFormGroup.value };
                    const proposalDOBObj = {
                        Day: formDataProposer.day,
                        Month: formDataProposer.month,
                        Year: formDataProposer.year
                    };
                    const proposerDob = new Date(proposalDOBObj.Year, proposalDOBObj.Month, proposalDOBObj.Day);
                    if (dobDate > proposerDob) {
                        validationErr = { rangeError: 'Eldest Member Date of birth can\'nt be less than Proposer Date of birth' };
                    }
                }

            }
            const cl = Object.keys(updatedValue)[0];
            ['year', 'month', 'day']
                .filter(c => c !== cl)
                .forEach(c => this.SelectInsurerFormGroup.controls[c].setErrors(validationErr));
            return validationErr;
        }
    }

    public ValidateProposerDOB(updatedValue) {
        this.DOB_DATE_RANGES = {
            MaxAge: 85,
            MinAge: 18
        };
        return this.FormValidators.validateDobFormatter(updatedValue, this.GetGoingFormGroup, this.DOB_DATE_RANGES);
    }

    private getTaskDetails() {
        const refineIncomingDate = eldestMemberDob => {
            const eldestMemberDobArr = eldestMemberDob.split('-');
            return eldestMemberDobArr[2] + '/' + eldestMemberDobArr[1] + '/' + eldestMemberDobArr[0];
        };
        this._getGoingCall.GetCallService().subscribe((resp: ActivitiModel.MTResponse<any>) => {
            if (!resp.errorBean) {
                if (resp) {
                    this.EditResponse = resp;
                    this.InsurerdResponse = this.EditResponse.hGIQuoteCriteria.insuredDetails;
                    this.InsuranceDetails = this.EditResponse.hGIQuoteCriteria.insuranceDetails;
                    this.insuredCount = this.InsurerdResponse.length;
                    this.PhoneNumber = this.EditResponse.mobile;
                    this.showOnlyGroupPlan = this.EditResponse.hGIQuoteCriteria.showOnlyGroupPlan ? this.EditResponse.hGIQuoteCriteria.showOnlyGroupPlan : false;
                    this.proposerDobResponse = this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobProposal ? refineIncomingDate(this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobProposal) : this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobEldestMember ? this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobEldestMember : null;
                    this.dobEldest = this.EditResponse.hGIQuoteCriteria.insuranceDetails.dobEldestMember;
                    this.PincodeResponse = this.EditResponse.hGIQuoteCriteria.insuranceDetails.pinCode;
                    this.selectedGender = this.EditResponse.hGIQuoteCriteria.insuranceDetails.gender;
                    if (this.insuredCount > 0) {
                        this.IsEdit = false;
                        this.isEditForgetGoingEdit = false;
                    }
                    this.setUserInput();
                    this.patchInsuringFor();
                    this.ValidateMobile();
                }
            }
        });
    }
    private CreatePayload() {
        this.insuringFor = 'Individual';

        const addr = this._pincodeService.GeoLocationDetails;
        const applAddress = <Model.AddressDetails>{};
        if (addr) {
            applAddress['pinCode'] = addr.pinCode;
            applAddress['pinId'] = addr.pinId;
            applAddress['city'] = addr.city;
            applAddress['cityId'] = addr.cityId;
            applAddress['state'] = addr.state;
            applAddress['stateId'] = addr.stateId;
            applAddress['countryId'] = addr.countryId;
            applAddress['country'] = addr.country;
            applAddress['type'] = 'CURRENT';
            applAddress['locality'] = null;
            applAddress['localityKey'] = null;
            applAddress['addSource'] = null;
            applAddress['appSource'] = null;
        }
        const formValue = this.GetGoingFormGroup.value;
        const d = parseInt(formValue['day'], 10);
        const m = parseInt(formValue['month'], 10);
        const day = d < 10 ? '0' + d : d;
        const month = m < 10 ? '0' + m : m;
        this.dobProposer = formValue['year'] + '-' + month + '-' + day;

        const formValueInsurer = this.SelectInsurerFormGroup.value;
        const d1 = parseInt(formValueInsurer['day'], 10);
        const m1 = parseInt(formValueInsurer['month'], 10);
        const day1 = d1 < 10 ? '0' + d1 : d1;
        const month1 = m1 < 10 ? '0' + m1 : m1;
        this.dobEldest = formValueInsurer['year'] + '-' + month1 + '-' + day1;

        if ((this.MembersAddedToList.length === 1 && this.MembersAddedToList.includes('Self')) ||
            (this.MembersAddedToList.indexOf('Father') < 0 &&
                this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)) {
            this.dobEldest = this.dobProposer;
        }

        const memberList = [];
        this.MembersAddedToList.forEach(element => {
            memberList.push({
                'no': element === 'Self' || element === 'Spouse' ? 0 : 1,
                'relationship': element,
            });
        });

        if (this.MembersAddedToList.length > 1) {
            this.insuringFor = 'Family';
        } else {
            this.insuringFor = 'Individual';
        }

        const InsProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
        const Payload = {
            'payload': {
                'mobile': this.GetGoingFormGroup.controls['mobileNumber'].value,
                'cityKey': this._pincodeService.GeoLocationDetails.cityId,
                'pincodeKey': this._pincodeService.GeoLocationDetails.pinId,
                'productCategoryCode': InsProductType ? InsProductType : 'HGI',
                'assetDetailReq': false,
                'applicationUTMParams': this.UtmStamping(),
                'tcApplicationFlag': 1,
                'quoteCriteria': {
                    'hGIQuoteCriteria': {
                        'applicationId': null,
                        'insuranceDetails': {
                            'pinCode': this.GetGoingFormGroup.controls['pinCode'].value,
                            'insuringFor': this.insuringFor,
                            'dobEldestMember': this.dobEldest,
                            'firstName': this.formatter.GetName('first', formValue['proposerName']),
                            'middleName': this.formatter.GetName('middle', formValue['proposerName']),
                            'lastName': this.formatter.GetName('last', formValue['proposerName']),
                            'dobProposal': this.dobProposer,
                            'gender': this.selectedGender,
                            'policyTenor': this.InsuranceDetails && this.InsuranceDetails.policyTenor ? this.InsuranceDetails.policyTenor : 1
                        },
                        'showOnlyGroupPlan': this.showOnlyGroupPlan,
                        'insuredDetails': memberList,
                        'medicalDeclaration': false
                    }
                }
            }
        };
        return Payload;
    }
    private UtmStamping() {
        let UTM = this._sharedService.getData('UTM');
        const UtmType = this._sharedService.getData('UtmType');
        UTM = UTM.split(':');
        if (UTM.length === 1) { UTM.length = []; }
        const sourcing = {
            'utmSource': (this._sessionHandlerService.GetSession(CommonConstants.QueryParamsKeys.IsMobile) == 'true') ? (UTM.length ? UTM[1] : '3IN1_APP_DI') : (UTM.length ? UTM[1] : CommonConstants.utmSources.organic),
            'utmMedium': UTM.length ? UTM[2] || '' : null, //(UtmType === 'pid' ? UTM[1] : UTM[2])
            'utmCampaign': UTM.length ? UTM[3] || '' : null,
            'utmContent': UTM.length ? UTM[4] || '' : null,
            'utmTerm': UTM.length ? UTM[5] || '' : null,
            'recVersion': 1
        };
        return sourcing;
    }
    public isPopupOpen() {
        this.isTncPopupOpen = false;
    }
    /* Back to same page on cancel */
    public Cancel($event) {
        this.getModalDirectiveInstanceBasedOnId(this.AnswerConfirmationPopupData.Id).hide();
    }



    bothDOBHasError() {
        const formData = { ...this.SelectInsurerFormGroup.value };

        if (formData.day && formData.month && formData.year) {
            const DOBObj = {
                Day: formData.day,
                Month: formData.month,
                Year: formData.year
            };

            const dobDate = new Date(DOBObj.Year, DOBObj.Month, DOBObj.Day);
            if (this.GetGoingFormGroup.get('day').value && this.GetGoingFormGroup.get('month').value &&
                this.GetGoingFormGroup.get('year').value) {
                const formDataProposer = { ...this.GetGoingFormGroup.value };
                const proposalDOBObj = {
                    Day: formDataProposer.day,
                    Month: formDataProposer.month,
                    Year: formDataProposer.year
                };
                const proposerDob = new Date(proposalDOBObj.Year, proposalDOBObj.Month, proposalDOBObj.Day);
                console.log(this.MembersAddedToList.indexOf('Father'));
                if (this.MembersAddedToList.indexOf('Father') !== -1 ||
                    this.MembersAddedToList.indexOf('Mother') !== -1 ||
                    this.MembersAddedToList.indexOf('Spouse') !== -1) {
                    if (dobDate > proposerDob) {
                        this.serviceMessage = 'Eldest Member Date of birth can\'nt be less than Proposer Date of birth';
                        this.hasDobError = true;

                    } else {
                        this.serviceMessage = '';
                        this.hasDobError = false;
                    }
                } else {
                    this.serviceMessage = '';
                    this.hasDobError = false;
                }
                return this.hasDobError;
            }

        }
    }

    // Next Button Click
    public Next() {

        if (this.bothDOBHasError()) {
            return;
        }

        if (this.GetGoingFormGroup.valid) {
            const payload = this.CreatePayload();
            this.showLoader = true;
            this._getGoingCall.PostCallService(payload).subscribe((response) => {
                this.googleAnalyticGetQuote();

                const Haserror = response.errors;
                const Payload = response.payload;
                this.setUserAuthToken(response);
                if (Payload && Payload !== undefined) {
                    if (Payload) {
                        this.setQuotesIs(Payload);
                    }
                    this.appQuoteCriteriaId = response.payload.appQuoteCriteriaId;

                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.groupHealthEligible,
                        response.payload.groupHealthEligible);
                    if (response.nextTask && response.nextTask.nextTaskKey === CommonConstants.Routes.Application.JourneyOtpVerification) {
                        this.showLoader = false;
                        this.showOtpDrawer = true;
                        this.mobileNumber = this.GetGoingFormGroup.get('mobileNumber').value;
                        this.generateOTP(this.onResendOTPReceived);
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                    } else {
                        this.routeHandlerService.RouteToNextTask(response.nextTask.nextTaskKey);
                    }
                } else {
                    if (response) {
                        response.forEach(element => {
                            if (CommonConstants.serviceError.includes(element.errorCode)) {
                                this.serviceMessage = element.errorMessage;
                            } else {
                                this.serviceMessage = 'Something went wrong. Please try again later';
                            }
                        });
                    }
                }
            },
                (error) => {
                    this.showLoader = false;
                });
        } else {
            this.GetGoingFormGroup.markAllAsTouched();
        }
    }
    public setQuotesIs(Payload) {
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.planQuoteCriteriaData, JSON.stringify(Payload));
    }
    private setUserAuthToken(responseData: any) {
        if (responseData.nextTask && responseData.nextTask !== null && responseData.nextTask !== ''
            && responseData.nextTask.nextTaskKey !== 'rejectApp') {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.processId,
                responseData.nextTask.processId);
        }
        if (responseData.nextTask && responseData.nextTask !== null && responseData.nextTask !== ''
            && responseData.nextTask.nextTaskKey === 'rejectApp') {
            this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.processId]);
        }
        if (responseData.payload && responseData.payload !== null && responseData.payload !== '') {
            /* If application Id is different then set selectedQuoteId to 0 */
            const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId) ?
                this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId) :
                null;
            if (applicationId && applicationId !== responseData.payload.applicationId) {
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.selectedQuoteId, 0);
            }
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.applicationId, responseData.payload.applicationId);
        }
        if (responseData.headers) {
            const authToken = responseData.headers.get('authtoken');
            if (authToken !== null && authToken !== '') {
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, authToken);
            }
        }
    }
    public setUserInput() {
        const proposerName = this.InsuranceDetails.firstName + ' ' +
            (this.InsuranceDetails.middleName ? this.InsuranceDetails.middleName + ' ' : '') +
            this.InsuranceDetails.lastName;
        if (proposerName !== 'null null') {
            this.GetGoingFormGroup.controls['proposerName'].setValue(proposerName);
        }

        this.GetGoingFormGroup.controls['gender'].setValue(this.selectedGender);
        this.GetGoingFormGroup.controls['mobileNumber'].setValue(this.PhoneNumber);
        let event = {
            target: {
                value: this.PincodeResponse
            }
        }
        this.OnPincodeChange(event);
        if (this.proposerDobResponse) {
            if (this.proposerDobResponse.includes('-')) {
                this.proposerDobResponse = this.proposerDobResponse.split('-').reverse().join('/');
            }
            const dobSplit = this.proposerDobResponse.split('/');
            const day = dobSplit[0];
            const month = dobSplit[1];
            const year = dobSplit[2];
            this.GetGoingFormGroup.controls['day'].setValue(day);
            this.GetGoingFormGroup.controls['month'].setValue(month);
            this.GetGoingFormGroup.controls['year'].setValue(year);
        }
    }
    // Pin code change function.
    public OnPincodeChange($event) {
        this.validatePIN = false;
        // latestPinCode logic is added to avoid the pincode service call getting fired on every keyup event
        this.GetGoingFormGroup.controls['pinCode'].setErrors({ 'incorrect': true });
        if (this.latestPinCode !== this.GetGoingFormGroup.controls['pinCode'].value) {
            this.latestPinCode = this.GetGoingFormGroup.controls['pinCode'].value;
            this._pincodeService.OnPinCodeChanged($event, () => {
                if (this._pincodeService.GeoLocationDetails) {
                    this.GetGoingFormGroup.controls['pinCode']
                        .setValue(this._pincodeService.GeoLocationDetails.pinCode);
                    this.GetGoingFormGroup.controls['pinCode'].setErrors(null);
                    this.GetGoingFormGroup.controls['state'].setValue(
                        this._pincodeService.GeoLocationDetails.city.concat(
                            ', ', this._pincodeService.GeoLocationDetails.stateShortName)
                    );
                    this.cityName = this._pincodeService.GeoLocationDetails.city;
                    // this.updateAreaCompleterUrl();
                    this.validatePIN = true;
                } else {
                    this.GetGoingFormGroup.controls['pinCode'].setValue('');
                    this.GetGoingFormGroup.controls['state'].setValue('');
                }
            });
        }
    }
    public prevent(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    }
    public ShowChildModal(id: string, contentType?: string): void {
        if (contentType) {
            this.initContentPopup();
        }
        this.getModalDirectiveInstanceBasedOnId(id).show();
    }
    private initContentPopup() {
        this.ContentPopup = {
            Id: 'content-modal',
            Title: 'Riders',
            Config: <CustomModalOptions>{ show: false, closeOption: true }
        };
    }
    private getModalDirectiveInstanceBasedOnId(popupId: string): any {
        return this.PopupComponent.filter((item: PopupComponent, index: number) => {
            return item.id === popupId;
        })[0].modalControl;
    }
    public HideChildModal(id: string): void {
        this.getModalDirectiveInstanceBasedOnId(id).hide();
    }


    // ---------------------------- otp ----------------------------

    private getFormValuesAsPayload(isActivityCall?: boolean) {
        const outputPayload = {};
        outputPayload['mobile'] = this.mobileNumber;
        outputPayload['productCode'] = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
        outputPayload['insProductType'] = CommonConstants.InsProductType;
        return outputPayload;
    }

    public generateOTP(callback): void {
        this.openDrawer('resumeOtpDrawerEdit');
        const outputPayload = this.getFormValuesAsPayload();
        outputPayload['otp'] = CommonConstants.DEFAULT_EMPTY_STRING;
        outputPayload['source'] = CommonConstants.SourceTypes.Journey;
        outputPayload['mfa'] = true;
        this._getGoingCall.postSendMobileOTP(outputPayload).subscribe(
            response => {
                if (!response.errorBean) {
                    this.isTimerStarted = true;
                    this.startClockTimer();
                    callback.call(this, response);
                } else if (CommonConstants.errorCodes.includes(response.errorBean[0].errorCode)) {
                    this.IsOTPResend = false;
                    this.ServiceError = response.errorBean[0].errorMessage;
                }
            },
            err => {

            }
        );
    }


    public buildHealthOtpForm() {
        this.healthOtpFormEdit = this._formBuilder.group({
            digit1: ['', Validators.compose([Validators.required])],
            digit2: ['', Validators.compose([Validators.required])],
            digit3: ['', Validators.compose([Validators.required])],
            digit4: ['', Validators.compose([Validators.required])],
            digit5: ['', Validators.compose([Validators.required])],
            digit6: ['', Validators.compose([Validators.required])],
        });

        this.healthOtpFormEdit.valueChanges.subscribe((updatedValue) => {
            this.wrongOtpMsg = null;
            console.log(this.healthOtpFormEdit);
            if (this.healthOtpFormEdit.valid) {
                this.googleAnalyticOtpTime('6');
                this.validateOtp();
            }
        });
    }

    private createOtpPayload() {
        const formValue = this.GetGoingFormGroup.value;
        const d = parseInt(formValue['day'], 10);
        const m = parseInt(formValue['month'], 10);
        const day = d < 10 ? '0' + d : d;
        const month = m < 10 ? '0' + m : m;
        this.dobforotp = formValue['year'] + '-' + month + '-' + day;
        const InsProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
        const outputPayload = {
            "applicationKey": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId),
            "dateOfBirth": null,
            "mobile": this.mobileNumber,
            "otp": this.healthOtpFormEdit.controls['digit1'].value + this.healthOtpFormEdit.controls['digit2'].value +
                this.healthOtpFormEdit.controls['digit3'].value + this.healthOtpFormEdit.controls['digit4'].value +
                this.healthOtpFormEdit.controls['digit5'].value + this.healthOtpFormEdit.controls['digit6'].value,
            "productcatcode": InsProductType ? InsProductType : 'HGI',
            "source": 'journey',
            "stage": null
        }
        return outputPayload;
    }

    public validateOtp() {
        console.log(this.healthOtpFormEdit);
        if (!this.healthOtpFormEdit.valid) {
            this.wrongOtpMsg = 'Please provide a valid OTP.';
        } else {
            this.IsOTPResend = false;
            const outputPayload = this.createOtpPayload();
            if (this.mobileOtpTrails >= 5) {
                this.resendOtpExceedFlag = true;
            }
            this.showLoader = true;
            this.ServiceOTPError = null;
            this._getGoingCall.postValidateOTP(outputPayload)
                .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
                    this.showLoader = false;
                    if (mtResponse.payload && mtResponse.payload.tokens) {
                        this.wrongOtpMsg = null;
                        const token = mtResponse.payload.tokens[0].token;
                        this.googleAnalyticSubmitOtp(true);

                        if (token) {
                            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, token);
                        }
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey,
                            token.guardKey);
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken,
                            this.formatter.ConvertGuradKeyToGuardToken(token.guardKey));
                        this.navigateToNextTask();
                    } else {
                        this.googleAnalyticSubmitOtp(false);
                    }
                    if ((!!mtResponse.errorBean && CommonConstants.errorCodes.includes(mtResponse.errorBean[0].errorCode)) || mtResponse.error.errorBean[0].errorCode) {
                        this.mobileOtpTrails++;
                        if (mtResponse.errorBean && mtResponse.errorBean[0].errorMessage)
                            this.ServiceOTPError = mtResponse.errorBean[0].errorMessage;
                        if (mtResponse.error && mtResponse.error.errorBean && mtResponse.error.errorBean[0].errorCode)
                            this.ServiceOTPError = 'Please provide a valid OTP.';
                    } else {
                        this.mobileOtpTrails++;
                    }
                },
                    (err) => {
                        this.showLoader = false;
                        this.mobileOtpTrails++;
                        this.wrongOtpMsg = 'Please provide a valid OTP.';
                        this.googleAnalyticSubmitOtp(false);
                    });
        }
    }

    private onResendOTPReceived(mtResponse: ActivitiModel.MTResponse<any>) {
        if (mtResponse.errorBean) {
            this.IsServiceFailure = true;
        }
    }

    // resend otp
    public resendOTP(formValue?: FormData) {
        this.healthOtpFormEdit.reset();
        this.IsOTPResend = false;
        if (this.resendOTPCount < 5) {
            this.timerOn = false;
            this.startClockTimer();
            this.timerOn = true;
            this.otpCountDown(60);

            this.generateOTP(this.onResendOTPReceived);

            this.IsOTPResend = true;
            this.resendOTPCount++;
        } else {
            this.resendOtpExceedFlag = true;
        }
    }

    public navigateToNextTask() {
        this.showLoader = true;

        this._moreAboutYouCall.PostCallService({ 'action': 'next' }, 'nomineeDetails').subscribe((response: any) => {
            this.showLoader = false;
            if (response.nextTask) {
                if (response) {
                    const Payload = response.payload;
                    this.setQuotesIs(Payload);
                }
                this.routeHandlerService.RouteToNextTask(response.nextTask.nextTaskKey);
            } else {
                this.routeHandlerService.RouteToNextTask(response.nextTaskKey);
            }
        },
            (error) => {
                this.ServiceError = 'Something went wrong. Please try again later';
                this.showLoader = false;
            });
    }

    // open drawer
    public openDrawer(itemId) {
        if (itemId === 'resumeOtpDrawerEdit') {
            document.getElementById('custom-header').style.display = 'none';
            this.isTimerStarted = true;
            this.startClockTimer();
            this.showOtpDrawer = true;
            this.timerOn = true;
            this.otpCountDown(60);
        }
        if (itemId === 'insuringForDrawer') {
            this.startInsuringForTimer();
        }
        this.drawer.filter((item, index) => {
            return (itemId === item.drawerId);
        })[0].open();
    }

    startClockTimer() {
        clearTimeout(this.setTime);
        this.setTime = setTimeout(() => {
            this.isTimerStarted = false;
        }, 60000);
    }

    // check for mobileNum eligible for whatsapp consent or not
    public GetWhatsappConsent() {
        const mobile = this.GetGoingFormGroup.controls['mobileNumber'].value;
        const requestPayload = {
            mobileno: mobile
        };
        if (mobile && this.GetGoingFormGroup.controls['mobileNumber'].valid && !this.IsCorrectMobile) {
            this._whatsappConsentService.GetConsent(requestPayload).subscribe((response) => {
                if (response.payload.cnsentflg == null || response.payload.cnsentflg === 0) {
                    this.ShowConsent = true;
                    this.checkUserConsent();
                } else {
                    this.ShowConsent = false;
                }
                console.log('response', response);
            });
        }
    }

    //  check for consent status
    public checkUserConsent() {
        const mobile = this.GetGoingFormGroup.controls['mobileNumber'].value;
        console.log('consent', this.whatsAppConsent);
        let whatsAppConsent: number;
        this.whatsAppConsent ? whatsAppConsent = 1 : whatsAppConsent = 0;
        const requestPayload = {
            'cnsentflg': whatsAppConsent,
            'consentChannel': 'WhatsApp',
            'consentIp': '',
            'consentProviderType': 'Customer',
            'consentUrl': null,
            'consentdt': this.today,
            'consentsource': 'Digital Platform',
            'deviceId': null,
            'email': null,
            'mobileno': mobile,
            'revokedt': null,
            'userkey': null
        };
        this._whatsappConsentService.AddConsent(requestPayload).subscribe((response) => {
            console.log('response', response);
        });
    }

    public OnGenderSelection(event) {
        console.log(event);
        console.log(this.GetGoingFormGroup.controls['gender'].value);
        this.selectedGender = GENDER_LIST.find(gl => gl === event);
    }

    public onKeydown(event, prevInput, nextInput) {
        setTimeout(() => {
            if (event.key === 'ArrowLeft' || event.key === 'Backspace') {
                prevInput.focus();
            }
            if (event.key === 'ArrowRight') {
                nextInput.focus();
            }
        }, 50);
    }

    public isMobile() {
        return (window.innerWidth < 767) ? true : false;
    }
    public onGenderInputEntry($event, nextInput) {
        nextInput.focus();
    }
    public scrollDown($event) {
        const input = $event.target;
        const maxLength = input.attributes.maxlength.value;
        const length = input.value.length;
        if (length >= maxLength) {
            window.scrollTo(0, 300);
        }
    }
    public validateYear() {
        const dateError = this.ValidateProposerDOB({ ['year']: this.GetGoingFormGroup.controls['year'].value });
        if (dateError) {
            this.GetGoingFormGroup.controls['year'].setErrors(dateError);
        }
        this.bothDOBHasError();
    }

    public validateYearEldest() {
        const dateError = this.ValidateDOB({ ['year']: this.SelectInsurerFormGroup.controls['year'].value });
        if (dateError) {
            this.SelectInsurerFormGroup.controls['year'].setErrors(dateError);
        }
        this.bothDOBHasError();
    }

    public isProposerDobValid() {
        return (this.GetGoingFormGroup.controls['day'].valid && this.GetGoingFormGroup.controls['month'].valid
            && this.GetGoingFormGroup.controls['year'].valid);
    }

    //  insuring for

    public patchInsuringFor() {
        this.MembersAddedToList = [];
        this.MembersAddedLable = '';
        const formControls = this.InsuredMemberList.map(control => new FormControl(false));
        const OtherMemberformControls = this.InsuredOtherMemberList.map(control => new FormControl(false));

        this.SelectInsurerFormGroup.patchValue({
            son: '',
            daughter: '',
            day: '',
            month: '',
            year: ''
        });
        this.SelectInsurerFormGroup.setControl('insurer', new FormArray(formControls));
        this.SelectInsurerFormGroup.setControl('otherInsurer', new FormArray(OtherMemberformControls));
        // dob format
        if (this.InsuranceDetails && this.InsuranceDetails.dobEldestMember) {
            this.formattedDOB = this.InsuranceDetails.dobEldestMember.split('-').reverse().join('/');
            const dobSplit = this.formattedDOB.split('/');
            const day = dobSplit[0];
            const month = dobSplit[1];
            const year = dobSplit[2];
            this.SelectInsurerFormGroup.controls['day'].setValue(day);
            this.SelectInsurerFormGroup.controls['month'].setValue(month);
            this.SelectInsurerFormGroup.controls['year'].setValue(year);
        }

        const firstLetterCaps = relationshipName => relationshipName.substr(0, 1).concat(
            relationshipName.substr(1, relationshipName.length).toLowerCase());
        let incomingSonCount = 0, incomingDaughterCount = 0;
        const insurerdResponse = this.InsurerdResponse;
        insurerdResponse.forEach(insured => {
            if (insured.relationship.toLowerCase() === 'son') {
                incomingSonCount++;
            } else if (insured.relationship.toLowerCase() === 'daughter') {
                incomingDaughterCount++;
            } else {
                this.MembersAddedToList.push(firstLetterCaps(insured.relationship));
            }
        });
        if (incomingSonCount === 1) {
            this.MembersAddedToList.push(`${SON}`);
        } else if (incomingSonCount > 1) {
            this.MembersAddedToList.push(`${SON}(${incomingSonCount})`);
        }
        if (incomingDaughterCount === 1) {
            this.MembersAddedToList.push(`${DAUGHTER}`);
        } else if (incomingDaughterCount > 1) {
            this.MembersAddedToList.push(`${DAUGHTER}(${incomingDaughterCount})`);
        }
        this.DaughterCount = incomingDaughterCount;
        this.SonCount = incomingSonCount;
        this.MembersAddedLable = this.MembersAddedToList.join(', ');
        if (this.DaughterCount === 4) {
            this.SelectInsurerFormGroup.get('son').disable();
        } else {
            this.SelectInsurerFormGroup.get('son').enable();
        }
        if (this.SonCount === 4) {
            this.SelectInsurerFormGroup.get('daughter').disable();
        } else {
            this.SelectInsurerFormGroup.get('daughter').enable();
        }
        this.checkInsurerCheckboxes();

        console.log(this.MembersAddedLable);

        this.resetInsurerDate();

    }

    public checkInsurerCheckboxes() {
        const setFormDOMData = index => {
            this.SelectInsurerFormGroup.value.insurer[index] = true;
            (<HTMLInputElement>document.getElementById('insuredMember' + index)).checked = true;
            const insurer = this.SelectInsurerFormGroup.controls['insurer'];
            insurer['controls'][index].setValue(true);
        };
        const setFormDOMDataSD = (sondaughter, sondaughterCount) => {
            this.SelectInsurerFormGroup.value[sondaughter] = true;
            (<HTMLInputElement>document.getElementById(sondaughter)).checked = true;
            this.SelectInsurerFormGroup.controls[sondaughter].setValue(sondaughterCount ? true : false);
            this.lastDaughterCount = this.substracFromFour(this.SonCount);
            this.lastSonCount = this.substracFromFour(this.DaughterCount);
        };
        const setFormDOMDataOthers = index => {
            this.SelectInsurerFormGroup.value.otherInsurer[index] = true;
            (<HTMLInputElement>document.getElementById('insuredOtherMember' + index)).checked = true;
            const insurer = this.SelectInsurerFormGroup.controls['otherInsurer'];
            insurer['controls'][index].setValue(true);
        };
        for (let i = 0, incomingInsuredMembersArrayLen = this.MembersAddedToList.length;
            i < incomingInsuredMembersArrayLen; i++) {
            switch (this.MembersAddedToList[i].toLowerCase()) {
                case 'self':
                    setFormDOMData(0);
                    break;
                case 'spouse':
                    setFormDOMData(1);
                    break;
                case 'father':
                    setFormDOMDataOthers(0);
                    break;
                case 'mother':
                    setFormDOMDataOthers(1);
                    break;
                case 'father-in-law':
                    setFormDOMDataOthers(2);
                    break;
                case 'mother-in-law':
                    setFormDOMDataOthers(3);
                    break;
                default:
                    console.log('Invalid Insurer...!');
            }
            if (this.MembersAddedToList[i].toLowerCase().indexOf('son') > -1) {
                setFormDOMDataSD('son', this.SonCount);
            }
            if (this.MembersAddedToList[i].toLowerCase().indexOf('daughter') > -1) {
                setFormDOMDataSD('daughter', this.DaughterCount);
            }
        }
        this.createInsuringForList();
    }


    public substracFromFour(sonDaughtercount) {
        return 4 - sonDaughtercount;
    }

    public counter(i: number) {
        return new Array(i);
    }

    public checkForSon(event) {
        if (!this.SelectInsurerFormGroup.value.son) {
            this.SonCount = 0;
            this.lastDaughterCount = this.substracFromFour(this.SonCount);
            this.createInsuringForList();
        } else {
            this.SonCount = 1;
            this.lastDaughterCount = this.substracFromFour(this.SonCount);
            this.createInsuringForList();
        }
        if (event.target.checked === false) {
            this.SelectInsurerFormGroup.get('daughter').enable();
        }
    }

    public checkForDaughter(event) {
        if (!this.SelectInsurerFormGroup.value.daughter) {
            this.DaughterCount = 0;
            this.lastSonCount = this.substracFromFour(this.DaughterCount);
            this.createInsuringForList();
        } else {
            this.DaughterCount = 1;
            this.lastSonCount = this.substracFromFour(this.DaughterCount);
            this.createInsuringForList();
        }
        if (event.target.checked === false) {
            this.SelectInsurerFormGroup.get('son').enable();
        }
    }

    public ChangeSonCount(id: number) {
        this.SonCount = id;
        this.SelectInsurerFormGroup.controls['son'].setValue(this.SonCount ? true : false);
        this.lastSonCount = this.substracFromFour(this.DaughterCount);
        this.lastDaughterCount = this.substracFromFour(this.SonCount);
        if (this.SonCount === 4) {
            this.SelectInsurerFormGroup.get('daughter').disable();
        } else {
            this.SelectInsurerFormGroup.get('daughter').enable();
        }
        this.createInsuringForList();
    }

    public ChangeDaughterCount(id: number) {
        this.DaughterCount = id;
        this.SelectInsurerFormGroup.controls['daughter'].setValue(this.DaughterCount ? true : false);
        this.lastSonCount = this.substracFromFour(this.DaughterCount);
        this.lastDaughterCount = this.substracFromFour(this.SonCount);
        if (this.DaughterCount === 4) {
            this.SelectInsurerFormGroup.get('son').disable();
        } else {
            this.SelectInsurerFormGroup.get('son').enable();
        }
        this.createInsuringForList();
    }

    public createInsuringForList() {
        this.MembersAddedToList = this.SelectInsurerFormGroup.value.insurer
            .map((checked, index) => checked ? this.InsuredMemberList[index].title : null)
            .filter(value => value !== null);
        const OtherMembersAddedToList = this.SelectInsurerFormGroup.value.otherInsurer
            .map((checked, index) => checked ? this.InsuredOtherMemberList[index].title : null)
            .filter(value => value !== null);
        this.MembersAddedToList = this.MembersAddedToList.concat(OtherMembersAddedToList);
        this.MembersAddedLable = this.MembersAddedToList.join(', ');
        if (this.SelectInsurerFormGroup.value.son) {
            if (this.SonCount > 0) {
                this.MembersAddedLable += (this.MembersAddedLable === '' || this.MembersAddedLable.length === 0) ? 'Son' : ', Son';
            }
            this.MembersAddedLable += (this.SonCount > 1) ? '(' + this.SonCount + ')' : '';
            for (let index = 0; index < this.SonCount; index++) {
                this.MembersAddedToList.push('son');
            }
        }
        if (this.SelectInsurerFormGroup.value.daughter) {
            if (this.DaughterCount > 0) {
                this.MembersAddedLable += (this.MembersAddedLable === '' ||
                    this.MembersAddedLable.length === 0) ? 'Daughter' : ', Daughter';
            }
            this.MembersAddedLable += (this.DaughterCount > 1) ? '(' + this.DaughterCount + ')' : '';
            for (let index = 0; index < this.DaughterCount; index++) {
                this.MembersAddedToList.push('daughter');
            }
        }
        this.GetGoingFormGroup.patchValue({
            insuredMembers: this.MembersAddedLable,
        });
        this.insurerCountCheck();
    }


    public insurerCountCheck() {
        if (this.MembersAddedToList.length === 0) {
            this.familyCheck = true;
            this.errorMessage = '';
        } else if (this.MembersAddedToList.length >= 7) {
            this.familyCheck = true;
            this.errorMessage = '(Maximum of 6 members can be insured, Maximum child members is 4';
        } else {
            this.familyCheck = false;
            this.errorMessage = '';
        }

    }


    public saveInsuringForData() {
        this.createInsuringForList();

        const memberList = [];
        this.MembersAddedToList.forEach(element => {
            memberList.push({
                'no': element === 'Self' || element === 'Spouse' ? 0 : 1,
                'relationship': element,
            });
        });

        this.resetInsurerDate();

        console.log(this.MembersAddedToList);

        this.googleAnalyticInsuringFor();

        this.hideDrawer('insuringForDrawer');


    }

    public resetInsurerDate() {
        if ((this.MembersAddedToList.indexOf('Father') < 0 &&
            this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)) {
            this.SelectInsurerFormGroup.patchValue({
                day: this.GetGoingFormGroup.get('day').value,
                month: this.GetGoingFormGroup.get('month').value,
                year: this.GetGoingFormGroup.get('year').value,
            });
        }

        this.bothDOBHasError();
    }

    public showEldestDOB() {
        return (this.MembersAddedToList.length === 1 && this.MembersAddedToList[0] === 'Self') || (this.MembersAddedToList.length < 1) ||
            (this.MembersAddedToList.indexOf('Father') < 0 &&
                this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0)
            ? false : true;
    }

    public getDateErrors() {
        return (
            ((!!this.SelectInsurerFormGroup.controls['day'].errors) &&
                (this.SelectInsurerFormGroup.controls['day'].errors.min || this.SelectInsurerFormGroup.controls['day'].errors.max)) ||
            ((!!this.SelectInsurerFormGroup.controls['month'].errors) &&
                (this.SelectInsurerFormGroup.controls['month'].errors.min || this.SelectInsurerFormGroup.controls['month'].errors.max)));
    }


    // close drawer
    public hideDrawer(itemId) {

        const selectedDrawer = this.drawer.filter((item, index) => {
            return (itemId === item.drawerId);
        });
        this.timerOn = false;
        if (!!selectedDrawer && selectedDrawer.length > 0) {
            selectedDrawer[0].close();
        }
    }

    public checkDOBValid() {


        if (this.MembersAddedToList.indexOf('Father') < 0 &&
            this.MembersAddedToList.indexOf('Mother') < 0 && this.MembersAddedToList.indexOf('Spouse') < 0) {
            return true;
        }


        return (this.SelectInsurerFormGroup.controls['day'].valid && this.SelectInsurerFormGroup.controls['month'].valid
            && this.SelectInsurerFormGroup.controls['year'].valid);
    }


    public googleAnalyticGetQuote() {
        const mobileNo = this.GetGoingFormGroup
            .controls['mobileNumber'].value.toString();

        const formValue = this.GetGoingFormGroup.value;
        const d = parseInt(formValue['day'], 10);
        const m = parseInt(formValue['month'], 10);
        const day = d < 10 ? '0' + d : d;
        const month = m < 10 ? '0' + m : m;
        const dobProposer = formValue['year'] + '-' + month + '-' + day;

        this._googleAnalyticsService.pushToDataLayer({
            'event': 'button_click',
            'pageType': 'Get Quote Page',
            'productName': 'Health Insurance',
            'productId': 'HGI',
            'clickText': 'Get Quote',
            'validation': 'Successful',          //E.g. Successful or Failed
            'customerType': '',        //E.g. ETB, PTB, NTB
            'customerId': '',          //If user is ETB
            'userId': '',          //If user is PTB, NTB
            'leadId': '',
            'mobile': mobileNo,
            'dob': dobProposer, // todo
            'insuringFor': this.insuringFor,
            'pinCode': this.GetGoingFormGroup.controls['pinCode'].value,
            'city': this.cityName ? this.cityName : this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.cityName),
            'appQuoteCriteriaId': this.appQuoteCriteriaId ? this.appQuoteCriteriaId : '',
            'stagePercentage': '', // todo
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }


    public googleAnalyticResendOtp() {
        const digit1Input = document.getElementById('digit1') as HTMLInputElement;
        digit1Input?.focus({ preventScroll: true });
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'link_click',
            'pageType': 'Get Quote Page',            //E.g. Get Quote Page
            'sectionHeading': 'OTP Verification',      //E.g. Overview
            'productId': 'HGI',            //E.g. HGI
            'productName': 'Health Insurance',         //E.g. Health Insurance, Motor Insurance
            'section': 'Card',                     //E.g. Card, BodyText, etc.
            'clickText': 'Resend OTP ?',
            'customerType': '',        //E.g. ETB, PTB, NTB
            'customerId': '',          //If user is ETB
            'userId': '',          //If user is PTB, NTB
            'leadId': '',
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }


    public googleAnalyticSubmitOtp(isSuccess) {
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'button_click',
            'pageType': 'Get Quote Page',            //E.g. Get Quote Page
            'productName': 'Health Insurance',         //E.g. Health Insurance, Motor Insurance
            'clickText': 'Submit OTP',           //E.g. Submit OTP
            'validation': isSuccess ? 'Successful' : 'Failed',          //E.g. Successful or Failed
            'customerType': '',        //E.g. ETB, PTB, NTB
            'customerId': '',          //If user is ETB
            'userId': '',          //If user is PTB, NTB
            'leadId': '',
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }
    public otpCountDown(seconds) {
        let min: any = Math.floor(seconds / 60);
        let sec: any = seconds % 60;
        min = min < 10 ? '0' + min : min;
        sec = sec < 10 ? '0' + sec : sec;
        document.getElementById('timer') ? document.getElementById('timer').innerHTML = min + ':' + sec : '';
        seconds -= 1;
        clearTimeout(this.timer);
        if (seconds >= 0 && this.timerOn) {
            this.timer = setTimeout(() => {
                this.otpCountDown(seconds);
            }, 1000);
            return;
        }
        if (!this.timerOn) {
            return;
        }
    }



    public googleAnalyticInsuringFor() {
        const eventValue = this.endFieldTimer(this.timerInsuringFor);
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Insuring For – ${this.MembersAddedToList.join('|')}`,
            'eventLabel': 'Success', // Success or Fail
            'eventValidation': 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page Edit',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue,// Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });
    }

    public googleAnalyticFullName() {
        const eventValue = this.endFieldTimer(this.fieldTimer);
        let error = null;
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'proposerName', 'required')) {
            error = 'Please provide Proposer name';
        }
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'proposerName', 'lastNameMandatory')) {
            error = 'Last name is mandatory.';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Full Name`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page Edit',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue, // Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    public googleAnalyticGender() {
        const eventValue = this.endFieldTimer(this.fieldTimer);
        let error = null;
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'gender', 'required')) {
            error = 'Mandatory field.';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Gender`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page Edit',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue, // Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    public googleAnalyticMobileNumber() {
        const eventValue = this.endFieldTimer(this.fieldTimer);
        let error = null;
        if (this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'required')) {
            error = 'Please provide your mobile number.';
        }
        if (this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'minlength')) {
            error = 'Mobile number should be 10 digit long.';
        }
        if (!this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'minlength') &&
            this.FormValidators.FieldHasSpecificError(this.GetGoingFormGroup, 'mobileNumber', 'pattern')) {
            error = 'Please provide valid mobile number.';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Mobile Number`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page Edit',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue, // Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    public googleAnalyticPinCode() {
        const eventValue = this.endFieldTimer(this.fieldTimer);
        let error = null;
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'pinCode', 'required')) {
            error = 'Please provide your PIN code';
        }
        if (this.FormValidators.HasError(this.GetGoingFormGroup, 'pinCode', 'pattern')) {
            error = 'Please provide your correct PIN code';
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `Pincode`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page Edit',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue,// Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    public googleAnalyticOtpTime(digit) {
        const eventValue = this.endFieldTimer(this.otpFieldtimer);
        let error = null;
        if (this.ServiceOTPError && this.resendOTPCount < 5) {
            error = this.ServiceOTPError;
        }
        if (this.wrongOtpMsg && this.resendOTPCount < 5) {
            error = this.wrongOtpMsg;
        }
        if (this.resendOTPCount >= 5) {
            error = `You've exhausted all 5 attempts to enter the correct OTP.
        Please resume your application after 10 minutes.`;
        }
        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': `OTP digit ${digit}`,
            'eventLabel': error ? 'Fail' : 'Success', // Success or Fail
            'eventValidation': error ? error : 'Yes', // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page Edit',    // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue, // Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startOtpFieldTimer();
        }
    }

    public googleAnalyticDOB(field, type?) {
        const eventValue = this.endFieldTimer(this.fieldTimer);
        const formGroup = type === 'eldest' ? this.SelectInsurerFormGroup : this.GetGoingFormGroup;
        let error = null;
        let value;
        switch (field) {
            case 'DD':
                value = formGroup.controls['day'].value ? formGroup.controls['day'].value : '';
                break;
            case 'MM':
                value = formGroup.controls['month'].value ? formGroup.controls['month'].value : '';
                break;
            case 'YY':
                value = formGroup.controls['year'].value ? formGroup.controls['year'].value : '';
                break;
            default:
            // code block
        }

        let DOB = '';

        if (type === 'eldest') {
            DOB = `eldest DOB - ${value} (${field})`;

            if (this.getDateErrors()) {
                error = 'please provide a valid date';
            }
        } else {
            DOB = `DOB - ${value} (${field})`;
        }

        if (this.FormValidators.HasError(formGroup, 'year', 'rangeError')) {
            error = formGroup.controls['year'].errors.rangeError;
        }
        if ((this.FormValidators.HasError(formGroup, 'day', 'required') ||
            this.FormValidators.HasError(formGroup, 'month', 'required') ||
            this.FormValidators.HasError(formGroup, 'year', 'required'))) {
            error = 'This is a mandatory field.';
        }

        this._googleAnalyticsService.pushToDataLayer({
            'event': 'fieldTiming',
            'eventCategory': '​Form Analytics Actions​',
            'eventAction': DOB,  // Eg. DOB – DD, MM, YY
            'eventLabel': error ? 'Fail' : 'Success',  // Success or Fail
            'eventValidation': error ? error : 'Yes',  // if Success – Yes or if Fail - Error message
            'section': 'Get Quote Page Edit',     // Eg. Get Quote Page, Your details, tenure, etc.
            'eventValue': eventValue, // Duration (Time spent by user on the field)
            'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
        });

        if (!error) {
            this.startFieldTimer();
        }
    }

    startInsuringForTimer() {
        this.timerInsuringFor = new Date().getTime();
    }

    startFieldTimer() {
        this.fieldTimer = new Date().getTime();
    }

    startOtpFieldTimer() {
        this.otpFieldtimer = new Date().getTime();
    }

    endFieldTimer(fieldTimer) {
        const diff = (new Date().getTime() - fieldTimer) / 1000;
        const seconds = Math.abs(Math.round(diff));
        return seconds;
    }

    scrollToSeo() {
        document.getElementById('seohidden').scrollIntoView(true);
    }
    public disableMobileControl() {
        this.GetGoingFormGroup.controls['mobileNumber'].setValue(this._sessionHandlerService.GetSession("mobile_number"));
        this.GetGoingFormGroup.controls['mobileNumber'].updateValueAndValidity();
    }
    public getSystemToken() {
        const productCode = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
        this._homeService.GetSystemAuthToken({
            productCode
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                const tokenObj = responseData.payload.tokens[0];
                console.log('tokens::', tokenObj);
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                if (this._routeContextProvider.GetQueryParams
                    (CommonConstants.QueryParamsKeys.IsMobile) === '1') {
                    const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.PSVToken);
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
                } else {
                    const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken);
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
                }
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken, this.formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
            } else {
            }
        });
    }

    public onDown(event, nextInput) {
        if (event.keyCode === 9) {
            // (<HTMLInputElement>document.getElementById('gender_0')).checked = true;
            this.GetGoingFormGroup.patchValue({
                gender: 'Male'
            });

        }
        if (event.keyCode === 27) {
            if (this.selectedGender === "Male") {
                this.curr_gender = "Male";
            }
            else if (this.selectedGender === "Female") {
                this.curr_gender = "Female";
            }
            this.GetGoingFormGroup.patchValue(
                {
                    gender: ''
                });
            this.selectedGender = "false";

        }
        this.selectedGender = this.GetGoingFormGroup.controls['gender'].value;
    }
}
